import Sidebar from '~/modules/myAccount/components/Sidebar';
import { useTranslation } from 'react-i18next';

const MyAccountMobileSidebar = () => {
  const { t } = useTranslation('app');
  return (
    <div className="container">
      <h1 className="text-title_2 font-[600] mb-4x">{t('myAccount')}</h1>
      <Sidebar />
    </div>
  );
};

export default MyAccountMobileSidebar;
